module.exports = __webpack_public_path__ + "img/404.d56a0342.png";